var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "bg-surface-secondary w-100" }, [
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-3" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("div", [
                  _c("h1", { staticClass: "h4 ls-tight" }, [
                    _vm._v("Cierre diario de " + _vm._s(_vm.id)),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.loading === ""
              ? _c("div", { staticClass: "col-auto" }, [
                  _c(
                    "div",
                    { staticClass: "hstack gap-2 justify-content-end" },
                    [
                      _c(
                        "div",
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "button",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass:
                                                  "btn btn-primary btn-m",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.PRINT()
                                                  },
                                                },
                                              },
                                              "button",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _c(
                                              "small",
                                              {
                                                staticClass:
                                                  "d-flex justify-content-center align-items-center",
                                              },
                                              [
                                                _vm.print > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "spinner-border spinner-border-sm mb-0",
                                                        attrs: {
                                                          role: "status",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "sr-only",
                                                          },
                                                          [_vm._v("Loading...")]
                                                        ),
                                                      ]
                                                    )
                                                  : _c("i", {
                                                      staticClass:
                                                        "bi bi-file-earmark-pdf",
                                                    }),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4023245759
                              ),
                            },
                            [
                              _vm._v(" "),
                              _c("small", [_vm._v("Descargar PDF")]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "main",
        { staticClass: "py-6 bg-surface-secondary", attrs: { id: "print" } },
        [
          _vm.loading == "data"
            ? _c("div", { staticClass: "container-fluid vstack gap-5" }, [
                _c("div", { staticClass: "w-100 py-3" }, [
                  _c("div", { staticClass: "text-center" }, [
                    _c(
                      "div",
                      {
                        staticClass: "spinner-border text-primary",
                        attrs: { role: "status" },
                      },
                      [
                        _c("span", { staticClass: "sr-only" }, [
                          _vm._v("Loading..."),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ])
            : _c("div", { staticClass: "container-fluid vstack gap-5" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-3 mb-3" }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "d-flex gap-3" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "icon icon-shape rounded-3 bg-orange text-white text-lg",
                            },
                            [_c("i", { staticClass: "bi bi-box" })]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "small",
                              { staticClass: "d-block text-md text-muted" },
                              [_vm._v("Paquetes")]
                            ),
                            _vm._v(" "),
                            _c("h5", { staticClass: "mb-1" }, [
                              _vm._v(_vm._s(_vm.data.count_packages)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-3 mb-3" }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "d-flex gap-3" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "icon icon-shape rounded-3 bg-danger text-white text-lg",
                            },
                            [_c("i", { staticClass: "bi bi-box" })]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "small",
                              { staticClass: "d-block text-md text-muted" },
                              [_vm._v("Paquetes Rechazados")]
                            ),
                            _vm._v(" "),
                            _c("h5", { staticClass: "mb-1" }, [
                              _vm._v(_vm._s(_vm.data.count_deliver_reject)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-3 mb-3" }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "d-flex gap-3" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "icon icon-shape rounded-3 bg-success text-white text-lg",
                            },
                            [_c("i", { staticClass: "bi bi-box" })]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "small",
                              { staticClass: "d-block text-md text-muted" },
                              [_vm._v("Paquetes entregados")]
                            ),
                            _vm._v(" "),
                            _c("h5", { staticClass: "mb-1" }, [
                              _vm._v(_vm._s(_vm.data.count_deliver_complete)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-3 mb-3" }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "d-flex gap-3" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "icon icon-shape rounded-3 bg-dark text-white text-lg",
                            },
                            [_c("i", { staticClass: "bi bi-box" })]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "small",
                              { staticClass: "d-block text-md text-muted" },
                              [_vm._v("Paquetes pendientes")]
                            ),
                            _vm._v(" "),
                            _c("h5", { staticClass: "mb-1" }, [
                              _vm._v(_vm._s(_vm.data.count_deliver_pendient)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg-3 mb-3" }, [
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c("div", { staticClass: "d-flex gap-3" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "icon icon-shape rounded-3 bg-primary text-white text-lg",
                            },
                            [_c("i", { staticClass: "bi bi-people" })]
                          ),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "small",
                              { staticClass: "d-block text-md text-muted" },
                              [_vm._v("Clientes")]
                            ),
                            _vm._v(" "),
                            _c("h5", { staticClass: "mb-1" }, [
                              _vm._v(_vm._s(_vm.data.count_clients)),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "card" }, [
                  _c(
                    "div",
                    { staticClass: "card-body p-0" },
                    [
                      [
                        _c(
                          "v-data-table",
                          {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.data.packages,
                              "hide-default-footer": "",
                              dense: "",
                              "items-per-page": -1,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "item.efectivo",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _vm._v(
                                        "\n                                    $ " +
                                          _vm._s(
                                            Number(
                                              item.efectivo_usd || 0
                                            ).toFixed(2)
                                          ) +
                                          " "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " ₡ " +
                                          _vm._s(
                                            Number(item.efectivo || 0).toFixed(
                                              2
                                            )
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.tarjeta",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _vm._v(
                                        "\n                                    $ " +
                                          _vm._s(
                                            Number(
                                              item.tarjeta_usd || 0
                                            ).toFixed(2)
                                          ) +
                                          " "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " ₡ " +
                                          _vm._s(
                                            Number(item.tarjeta || 0).toFixed(2)
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.transferencia",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _vm._v(
                                        "\n                                    $ " +
                                          _vm._s(
                                            Number(
                                              item.transferencia_usd || 0
                                            ).toFixed(2)
                                          ) +
                                          " "
                                      ),
                                      _c("br"),
                                      _vm._v(
                                        " ₡ " +
                                          _vm._s(
                                            Number(
                                              item.transferencia || 0
                                            ).toFixed(2)
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: "item.sinpe_movil",
                                  fn: function (ref) {
                                    var item = ref.item
                                    return [
                                      _vm._v(
                                        "\n                                    ₡ " +
                                          _vm._s(
                                            Number(
                                              item.sinpe_movil || 0
                                            ).toFixed(2)
                                          ) +
                                          "\n                                "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm._v(" "),
                            _vm._v(" "),
                            _vm._v(" "),
                            _vm._v(" "),
                            _c("template", { slot: "body.append" }, [
                              _c("tr", { staticClass: "bg-dark" }, [
                                _c(
                                  "td",
                                  { staticClass: "text-start text-white" },
                                  [_vm._v("Total")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-start text-white" },
                                  [
                                    _vm._v(
                                      "\n                                            $ " +
                                        _vm._s(
                                          Number(_vm.efectivo_usd || 0).toFixed(
                                            2
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " ₡ " +
                                        _vm._s(
                                          Number(_vm.efectivo || 0).toFixed(2)
                                        ) +
                                        "\n                                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-start text-white" },
                                  [
                                    _vm._v(
                                      "\n                                            $ " +
                                        _vm._s(
                                          Number(_vm.tarjeta_usd || 0).toFixed(
                                            2
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " ₡ " +
                                        _vm._s(
                                          Number(_vm.tarjeta || 0).toFixed(2)
                                        ) +
                                        "\n                                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-start text-white" },
                                  [
                                    _vm._v(
                                      "\n                                            $ " +
                                        _vm._s(
                                          Number(
                                            _vm.transferencia_usd || 0
                                          ).toFixed(2)
                                        ) +
                                        " "
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      " ₡ " +
                                        _vm._s(
                                          Number(
                                            _vm.transferencia || 0
                                          ).toFixed(2)
                                        ) +
                                        "\n                                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "td",
                                  { staticClass: "text-start text-white" },
                                  [
                                    _vm._v(
                                      "\n                                            ₡ " +
                                        _vm._s(
                                          Number(_vm.sinpe_movil || 0).toFixed(
                                            2
                                          )
                                        ) +
                                        "\n                                        "
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ],
                          2
                        ),
                      ],
                    ],
                    2
                  ),
                ]),
              ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }